<template>
  <div class="doughnut_chart_box">
    <doughnut-chart v-if="Object.keys(chartData).length !== 0" :chart-data="chartData" :options="options"></doughnut-chart>
    <v-tooltip v-if="centerTooltip" color="#202126" bottom>
      <template #activator="{ on, attrs }">
        <div class="doughnut_inner_text" v-bind="attrs" v-on="on">
          <div>{{ description }}</div>
          <div>
            <span>{{ `${number}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</span>
            {{ unit }}
          </div>
        </div>
      </template>
      <span>{{ centerTooltip }}</span>
    </v-tooltip>
    <template v-else>
      <div class="doughnut_inner_text">
        <div>{{ description }}</div>
        <div>
          <span>{{ number }}</span>
          {{ unit }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import DoughnutChart from '@/components/chart/DoughnutChart';
import { mapState } from 'vuex';

export default {
  name: 'StatusDoughnutChart',
  components: {
    DoughnutChart,
  },
  props: {
    description: {
      type: String,
      default: '',
    },
    number: {
      type: Number,
      default: 0,
    },
    unit: {
      type: String,
      default: '',
    },
    chartData: {
      type: Object,
      default: null,
    },
    centerTooltip: {
      type: String,
      default: '',
    },
    graphTooltip: Boolean,
  },
  data: () => ({
    options: {
      cutoutPercentage: 75,
      legend: {
        display: false,
      },
      tooltips: {
        backgroundColor: '#202126',
        xPadding: 30,
        yPadding: 10,
        bodyFontSize: 14,
        displayColors: false,
        caretSize: 0,
      },
    },
  }),
  computed: {
    ...mapState('commonValue', ['healthStatus']),
  },
  created() {
    if (this.graphTooltip) {
      const tooltipLabels = [];
      this.chartData.labels.forEach(element => {
        tooltipLabels.push(this.healthStatus[element].text);
      });
      this.options.tooltips.callbacks = {
        title: function () {
          return '';
        },
        label: function (tooltipItem) {
          return tooltipLabels[tooltipItem.index];
        },
      };
    } else {
      this.options.tooltips.enabled = false;
    }
  },
};
</script>

<style scoped>
.doughnut_chart_box {
  position: relative;
}
.doughnut_inner_text {
  position: absolute;
  width: 150px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.doughnut_inner_text > div:nth-child(1) {
  font-size: 14px;
  color: #8a92a1;
}
.doughnut_inner_text > div:nth-child(2) {
  font-size: 14px;
  color: #656e81;
  line-height: normal;
}

.doughnut_inner_text > div:nth-child(2) > span {
  font-size: 42px;
  color: #030d21;
}
</style>
